var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{staticClass:"mt-4",attrs:{"allowed-dates":_vm.allowedMonths,"type":"month","min":"2017-06","max":"2019-10","color":"primary"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }